var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 33,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_385_2",
    transform: "matrix(0.02 0 0 0.0193939 0 0.0151515)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_385_2",
    width: 50,
    height: 50,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAAC+UlEQVR4nO2Zy0vUURTHv72oiKSixyZ6QLSoEEG858wouiiijHaZiyCEzCCFgmhRUdiqFhG0cFGbiP6EECqodWEULiIIXARS6BBBD5MefuPe39A0juOM+rv39zP8wtnMuXM5n5n7OPccYEH/s4hFYMuKqsemVjT7QR0CzaHyY5rWgnodlJtIraiPQGVk8gCUbQVfy1JQukAZzfu/gKYGqRMze0CdKIA4+wbqBVBaQX09yWetB6kT9e4UgVayt+naK5RNoHyfBYi1fQkEnNnoNjKlA9TzoN4A5R4oL2cJYe0FqGdBPQpqI9i4Baxf5hskO4eAZ2IToF70CKIrQf0RBkZa/YE4GHkVAOQ3qOs8g+jtACCDfiEikM4AIH2h0hDfIMc8Q2QzhRTDqw24o94PhDkCylgACOZtCNQdMUPImfxJwsD2AczWxQXRlQAACyafwExzDCBtS0C9kyDIcIz/in35SW8CIIOg2RwPRBGQ9oTbK/IQzK6OH+IvjJwLANLnlrRX2ax03ieMVtT+ACC98CpiMSgfAyytfs8gUhtoo4/6BjkdBkRZVEqKHyTTDMrVfMXkcVTikc8xBj8GyjtQnrsENbgol+YQ/EnQbAdrV4UPvASkacPsykHyxh0gqRL1fpmAn4EyUsbXidSJIpN+7WFQj+cr9GtAvQXKr3/8I1VX7r3KFtJKPrMvO/0K6hVXOirxS320kR3I5WLfgeWgHkZwUU+Bma2lT+EK2Wp0qXaB9esnzXcCNN1eYp0+INMN6rV45rLLzx7lJjGQ3LTr3PVEbPmoYff0c8nBaLmZxEDsWu+Y2p/ZGz2M3Jif0WYv09ihPkkBiA4Uf96wM+pWTXlvDIOZtuLx2bqC3yQKYgOU/BFre4PjVVyGT0Gzq/T+MUmDuB5Hboa3+rhriBZV903iIDGZSTOIvcHLpijzAiQXlZBMjctso2rl+/kEkvsLUPKdSkAmFSDlAaoGMomCVA9QEcgkASLtUYs6hpedA7JzSXsssS0IyesP3qqib1iEWa4AAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrize);
export default __webpack_public_path__ + "static/media/Prize.a3fc909c4b748e181cf970849a3980a5.svg";
export { ForwardRef as ReactComponent };